import {dataHooks} from '@wix/data-hooks'

export const reservationDetailsSectionDataHooks = dataHooks<{
  changeReservation: {}
  locationSummary: {}
}>('reservation-details-section')
